import React from "react"
import { Currency } from "../../util/numbers"
import { PayoutData } from "./types"
import { td, tdLabel } from "./constants"

const ShowSummary: React.FC<{ payout: PayoutData }> = ({ payout }) => (
  <table className="w-full table-fixed">
    <colgroup>
      <col className="w-[20%]" />
      <col className="w-[20%]" />
      <col className="w-[25%]" />
      <col className="w-[15%]" />
      <col className="w-[20%]" />
    </colgroup>
    <tbody>
      {payout.tickets_post?.venue_name && (
        <tr>
          <td className={tdLabel} colSpan={2}>
            Venue
          </td>
          <td className={`${td} text-right font-bold`} colSpan={3}>
            {payout.tickets_post.venue_name}
          </td>
        </tr>
      )}
      {payout.tickets_post && payout.source_type === "source_tips" ? (
        <tr>
          <td className={tdLabel} colSpan={4}>
            Donations Made
          </td>
          <td className={`${td} text-right`}>
            {payout.tickets_post.tips_count}
          </td>
        </tr>
      ) : (
        payout.tickets_post && (
          <tr>
            <td className={tdLabel} colSpan={4}>
              Tickets Sold
            </td>
            <td className={`${td} text-right`}>
              {payout.tickets_post.tickets_count}
            </td>
          </tr>
        )
      )}
      {!!payout.tickets_post?.tickets_via_digest && (
        <tr>
          <td className={`${tdLabel} text-xs text-gray-500 pl-4`} colSpan={4}>
            ...via weekly digest
          </td>
          <td className={`${td} text-right text-xs text-gray-500`}>
            {payout.tickets_post.tickets_via_digest}
          </td>
        </tr>
      )}
      {!!payout.tickets_post?.tickets_via_share && (
        <tr>
          <td className={`${tdLabel} text-xs text-gray-500 pl-4`} colSpan={4}>
            ...via bandNada shares
          </td>
          <td className={`${td} text-right text-xs text-gray-500`}>
            {payout.tickets_post.tickets_via_share}
          </td>
        </tr>
      )}
      <tr>
        <td className={tdLabel} colSpan={4}>
          Total Revenue
        </td>
        <td className={`${td} text-right`}>{Currency(payout.total_amount)}</td>
      </tr>
      <tr>
        <td className={tdLabel} colSpan={4}>
          bandNada Fee
        </td>
        <td className={`${td} text-right text-red-600`}>
          {Currency(payout.bn_share)}
        </td>
      </tr>
      {payout.waived_bn_fees > 0 && (
        <tr>
          <td className={tdLabel} colSpan={4}>
            Waived Fees
          </td>
          <td className={`${td} text-right`}>
            {Currency(payout.waived_bn_fees)}
          </td>
        </tr>
      )}
      <tr className="border-t border-gray-400">
        <td className={tdLabel} colSpan={4}>
          Total Payout
        </td>
        <td className={`${td} text-right font-bold`}>
          {Currency(payout.band_share)}
        </td>
      </tr>
    </tbody>
  </table>
)

export default ShowSummary
